import type { ComponentConfigV2, GuideOptions } from '@/types/configurationV2'

export default function GuideOptionsEditor({
  component,
  onUpdate,
}: { component: ComponentConfigV2; onUpdate: (u: ComponentConfigV2) => void }) {
  const options = component.options as GuideOptions
  const audioResponse = options.audioResponse ?? { enabled: false, required: false }
  const update = (patch: Partial<GuideOptions>) =>
    onUpdate({ ...component, options: { ...options, ...patch } })

  return (
    <div className="space-y-3">
      <div>
        <div className="text-xs text-gray-500 mb-1">템플릿 ID</div>
        <input
          type="text"
          value={options.templateId ?? ''}
          onChange={(e) => update({ templateId: e.target.value || null })}
          placeholder="템플릿 선택 (추후 구현)"
          className="w-full px-2 py-1 text-xs border border-gray-300 rounded"
        />
      </div>

      <label className="flex items-center gap-1.5 text-xs">
        <input
          type="checkbox"
          checked={options.showMessage}
          onChange={(e) => update({ showMessage: e.target.checked })}
        />
        안내 메시지 표시
      </label>

      {options.showMessage && (
        <>
          <textarea
            value={options.message ?? ''}
            onChange={(e) => update({ message: e.target.value })}
            placeholder="안내 메시지 내용"
            rows={3}
            className="w-full px-2 py-1 text-xs border border-gray-300 rounded"
          />
          <textarea
            value={options.messageEn ?? ''}
            onChange={(e) => update({ messageEn: e.target.value })}
            placeholder="안내 메시지 내용 (영문)"
            rows={3}
            className="w-full px-2 py-1 text-xs border border-gray-300 rounded"
          />
        </>
      )}

      <label className="flex items-center gap-1.5 text-xs">
        <input
          type="checkbox"
          checked={audioResponse.enabled}
          onChange={(e) => update({
            audioResponse: {
              enabled: e.target.checked,
              required: e.target.checked ? audioResponse.required ?? false : false,
            },
          })}
        />
        Audio Response 퀴즈 (quiz_location: explain)
      </label>

      <label className="flex items-center gap-1.5 text-xs">
        <input
          type="checkbox"
          checked={audioResponse.required ?? false}
          disabled={!audioResponse.enabled}
          onChange={(e) => update({ audioResponse: { ...audioResponse, required: e.target.checked } })}
        />
        자동완료 시 음성 응답 필수
      </label>
    </div>
  )
}
